import { render, staticRenderFns } from "./doctorHelp.vue?vue&type=template&id=b9e4e8b0&scoped=true&"
import script from "./doctorHelp.vue?vue&type=script&lang=js&"
export * from "./doctorHelp.vue?vue&type=script&lang=js&"
import style0 from "./doctorHelp.vue?vue&type=style&index=0&id=b9e4e8b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e4e8b0",
  null
  
)

export default component.exports